import { baseCrudFactory } from "~/stores/base.crud.store.ts"
import { mapById } from "~/helpers"

export const useRoleStore = baseCrudFactory({
    endpoint: "admin/roles",
    primaryKey: "id",
    title: "roles",
    getters: {
        roleByName: (state) => {
            return mapById(state.items, "name")
        },
    },
})
